import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared';


@Component({
  templateUrl: 'welcome.component.html',
  styleUrls: ['../style.component.css']
  
  
})

export class WelcomeComponent implements OnInit {
  public data: Object;
  constructor(
    
    private router: Router,
   
    
  ) {
    
  }


  
  
  ngOnInit() {
    
    
    
   
  }
  
   
}
  

   
 
  

